import {useState} from 'react';
import {Spinner} from 'react-bootstrap';
import {FaCommentDots} from 'react-icons/fa';
import {useNavigate} from 'react-router-dom';
import {useChat} from './ChatProvider';

export default function JobPropertyChatButton({job}) {
    const chat = useChat();
    const navigate = useNavigate();
    const [opening, setOpening] = useState(false);
    const [error, setError] = useState('');
    const propertyId = job?.property_id;
    const cosJobId = job?.cos_job_id;

    if (!propertyId || !cosJobId) return null;

    const openPropertyChat = async event => {
        event.stopPropagation();
        if (opening) return;
        setOpening(true);
        setError('');
        try {
            const result = await chat.ensurePropertyChannel(propertyId, cosJobId);
            if (!result?.conversation?.id) throw new Error('Property Chat did not return a conversation');
            navigate(`/chat/${result.conversation.id}`);
        } catch (requestError) {
            setError(requestError?.message || 'Unable to open Property Chat');
        } finally {
            setOpening(false);
        }
    };

    return (
        <span className="d-inline-flex align-items-center">
            <button
                type="button"
                onClick={openPropertyChat}
                disabled={opening}
                aria-label="Open Property Chat"
                title={error || 'Open Property Chat'}
                className="border-0 bg-transparent p-0 d-inline-flex align-items-center"
                style={{marginLeft: '10px', color: error ? 'var(--bs-danger)' : 'grey'}}
            >
                {opening
                    ? <Spinner animation="border" size="sm" aria-hidden="true" />
                    : <FaCommentDots size={22} aria-hidden="true" />}
            </button>
            {error ? <span role="alert" className="visually-hidden">{error}</span> : null}
        </span>
    );
}
